import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { IgAlert } from "@intelligems/ig-theme/IgAlert";
import { IgLink } from "@intelligems/ig-theme/IgLink";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { officialCategoryName } from "@intelligems/ig-utils/common";
import Grid from "@mui/material/Grid";
import { DataExportDialog } from "@src/features/analytics/baseDashboard/DataExportDialog";
import { useReadOnlyMode } from "@src/features/publicShareLinks/hooks/useReadOnlyMode";
import { useDialogs } from "@src/hooks/dialog";
import { SETTINGS_ROUTES } from "@src/routes/routes";
import { selectedExperience } from "@src/store/slices/experiences";
import { SettingsSectionId } from "@src/types/navigation";

export const InsufficientCogsAlert = () => {
  const navigate = useNavigate();
  const experience = useSelector(selectedExperience);
  const { openDialog } = useDialogs();
  const { isReadOnly } = useReadOnlyMode();

  // Handle case where experience might not be loaded yet
  if (!experience) {
    return null;
  }

  const message = (
    <IgTypography>
      We may be missing COGS information for products sold during the{" "}
      {officialCategoryName(experience.category, false)}. Use the{" "}
      <IgLink onClick={() => openDialog("dataExport")}>
        export of order line items
      </IgLink>{" "}
      to see which COGS information is missing. Please note items with no
      associated COGS contribute to profit figures with 100% margin which may
      skew results.
    </IgTypography>
  );

  return (
    <>
      <Grid sx={{ width: "100%" }}>
        <IgAlert
          alertKey={"insufficient-cogs-alert"}
          title={`Incomplete COGS information`}
          message={message}
          severity={"warning"}
          primaryButton={
            isReadOnly
              ? undefined
              : {
                  cta: "Provide COGS",
                  onClick: () => {
                    void navigate(
                      `${SETTINGS_ROUTES.Settings}#${SettingsSectionId.Cogs}`
                    );
                  },
                }
          }
        />
      </Grid>
      {!isReadOnly && <DataExportDialog experience={experience} />}
    </>
  );
};
